import { exeRequest } from '../utils/APIUtils';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    // ============== MARQUES ==============
    // Liste des marques
    getBrands: async () => exeRequest('/admin/vehicle-brands', 'GET'),

    // Détail d'une marque
    getBrandById: async (id) => exeRequest(`/admin/vehicle-brands/${id}`, 'GET'),

    // Créer une marque
    addBrand: async (data) => exeRequest('/admin/vehicle-brands', 'POST', data),

    // Modifier une marque
    updateBrand: async (id, data) => exeRequest(`/admin/vehicle-brands/${id}`, 'PUT', data),

    // Supprimer une marque
    deleteBrand: async (id) => exeRequest(`/admin/vehicle-brands/${id}`, 'DELETE'),

    // Toggle actif/inactif
    toggleBrand: async (id, isActive) => exeRequest(`/admin/vehicle-brands/${id}/toggle`, 'PATCH', { isActive }),

    // Import en masse
    importBrands: async (brands) => exeRequest('/admin/vehicle-brands/import', 'POST', { brands }),

    // ============== MODELES ==============
    // Modèles d'une marque
    getModelsByBrand: async (brandId) => exeRequest(`/admin/vehicle-brands/${brandId}/models`, 'GET'),

    // Tous les modèles
    getAllModels: async () => exeRequest('/admin/vehicle-models', 'GET'),

    // Créer un modèle
    addModel: async (data) => exeRequest('/admin/vehicle-models', 'POST', data),

    // Modifier un modèle
    updateModel: async (id, data) => exeRequest(`/admin/vehicle-models/${id}`, 'PUT', data),

    // Supprimer un modèle
    deleteModel: async (id) => exeRequest(`/admin/vehicle-models/${id}`, 'DELETE'),

    // Toggle actif/inactif
    toggleModel: async (id, isActive) => exeRequest(`/admin/vehicle-models/${id}/toggle`, 'PATCH', { isActive }),

    // Import en masse de modèles
    importModels: async (brandId, models) => exeRequest('/admin/vehicle-models/import', 'POST', { brandId, models }),

    // Seed des marques et modèles (données initiales)
    seed: async () => exeRequest('/admin/vehicle-brands/seed', 'POST'),
};
